import { getScrollContainer, getScrollEventTarget, getScrollTop, scrollContainerMediaQuery } from '@theme/scroll-container';

const SHOW_AFTER = 720;
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class XstoBackToTop extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.dataset.ready = 'true';
    this.button = this.querySelector('button');
    this.onScroll = this.onScroll.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
    this.button?.addEventListener('click', () => {
      getScrollContainer().scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });

    this.bindScrollTarget();
    scrollContainerMediaQuery.addEventListener('change', this.onViewportChange);
    this.update();
  }

  disconnectedCallback() {
    this.scrollTarget?.removeEventListener('scroll', this.onScroll);
    scrollContainerMediaQuery.removeEventListener('change', this.onViewportChange);
  }

  bindScrollTarget() {
    this.scrollTarget?.removeEventListener('scroll', this.onScroll);
    this.scrollTarget = getScrollEventTarget();
    this.scrollTarget.addEventListener('scroll', this.onScroll, { passive: true });
  }

  onViewportChange() {
    this.bindScrollTarget();
    this.update();
  }

  onScroll() {
    if (this.frame) return;

    this.frame = requestAnimationFrame(() => {
      this.frame = undefined;
      this.update();
    });
  }

  update() {
    const isVisible = getScrollTop() > SHOW_AFTER;
    this.toggleAttribute('data-visible', isVisible);
    this.setAttribute('aria-hidden', String(!isVisible));
    if (this.button) this.button.tabIndex = isVisible ? 0 : -1;
  }
}

if (!customElements.get('xsto-back-to-top')) {
  customElements.define('xsto-back-to-top', XstoBackToTop);
}
